import debounce from 'lodash/debounce'

export function useWatchScreenSize () {
  let currentWindow = ref({
    width: 0,
    height: 0
  })

  const handleResize = () => {
    currentWindow.value.width = window.innerWidth
    currentWindow.value.height = window.innerHeight
  }

  if (process.client) {
    window.addEventListener('resize', debounce(handleResize, 300))
    handleResize()
  }

  onUnmounted(() => {
    window.removeEventListener('resize', debounce(handleResize, 300))
  })
}

export function useResponsive () {
  let currentWindow = ref({
    width: 0,
    height: 0
  })

  const handleResize = () => {
    currentWindow.value.width = window.innerWidth
    currentWindow.value.height = window.innerHeight
  }

  const isUpToXLarge = computed(() => {
    return currentWindow.value.width < 1200
  })

  const isUpToMedium = computed(() => {
    return currentWindow.value.width < 768
  })

  const isFromMediumToXLarge = computed(() => {
    return currentWindow.value.width >= 768 && currentWindow.value.width < 1200
  })

  if (process.client) {
    window.addEventListener('resize', debounce(handleResize, 300))
    handleResize()
  }

  onUnmounted(() => {
    window.removeEventListener('resize', debounce(handleResize, 300))
  })

  return {
    isUpToXLarge,
    isUpToMedium,
    isFromMediumToXLarge,
    currentWindow,
  }
}


export function useModalProcess() {
  const modalVisible = ref(false)

  const showProcessing = () => {
    modalVisible.value = true
  }

  const hideProcessing = () => {
    modalVisible.value = false
  }

  return {
    modalVisible,
    showProcessing,
    hideProcessing
  }
}
